import { urlForImage } from '@/sanity/lib/image'
import { useMediaQuery } from '@mui/material'
import Image from 'next/image'

const Banner = ({ desktop, mobile }) => {
  const isMobile = useMediaQuery('(max-width:767px)')
  const base =
    'relative w-full aspect-[3/4] md:aspect-video mt-mediumMobile lg:mt-mediumDesktop'

  return (
    <div className={base}>
      {!isMobile && (
        <Image
          src={urlForImage(desktop).url()}
          alt={desktop.alt}
          fill
          placeholder="blur"
          blurDataURL={desktop.metadata.lqip}
          className="object-cover"
        />
      )}
      {isMobile && (
        <Image
          src={urlForImage(mobile).url()}
          alt={mobile.alt}
          fill
          placeholder="blur"
          blurDataURL={mobile.metadata.lqip}
          className="object-cover"
        />
      )}
    </div>
  )
}

export default Banner
